export const homePage = {
    numberSte: 'Số lượng: <span class="color-green">{count}</span> NFT',
    title: 'Bộ sưu tập NFT của AIS',
    titleContent: 'Điều kiện mua INO:',
    lineContent1: 'Đã xác thực danh tính',
    lineContent2: 'Mỗi tài khoản mua tối đa 1 áo nam và 1 áo nữ',
    buttonBuy: 'Mua',
    soldOut: 'Bán hết',
    numberProducts: 'SL: <span class="color-red">{count}</span> NFT',
    noLoginTitle: 'Bạn chưa đăng nhập',
    contentNoLogin: 'Bạn cần đăng nhập để có thể mua NFT.',
    buttonNoLogin: 'Đăng nhập',
    buttonVerify: 'Xác thực danh tính',
    changePass: 'Đổi mật khẩu',
    logOut: 'Đăng xuất',
    ok: 'Xác nhận',
    noVerifyTitle: 'Bạn chưa xác thực danh tính',
    chooseWallet: 'Chọn ví thanh toán',
    notEnoughMoney: 'Số dư của bạn không đủ.',
    confirmBuy: 'Xác nhận mua NFT',
    price: 'Giá mua',
    confirmBuyButton: 'Xác nhận mua',
    loginBuy: 'Đăng nhập để mua',
    timeup: 'Đợt bán đã kết thúc',
    remain: 'Còn lại: {remain}',
    confirmSellButton: 'Bán',
    titleConnectWallet: 'Hãy kết nối ví',
    youNeedConnectMetamask: 'Bạn cần kết nối ví để có thể mua NFT.',
    connectWallet: 'Kết nối ví',
    noVerifyContent: 'Bạn cần xác mình danh tính để có thể mua NFT.',
    noVerifyButton: 'Xác thực',
    rejectVerifyTitle: 'Tài khoản của bạn đã bị \n  từ chối xác thực',
    rejectVerifyContent: 'Bạn cần xác thực lại để có thể mua NFT',
    rejectVerifyButton: 'Xác thực lại',
    pendingVerifyTitle: 'Tài khoản của bạn đang \n đợi xác thực',
    penddingVerifyButton: 'Ok',

    approvedTitle: 'Sắp mở bán',
    approvedSubTitle1: 'Bắt đầu mở bán vào:',
    approvedLine1: 'Ngày 21/06/2022 08:00 UTC',

    approvedLine2: ' Đợt 2: 70 NFT Áo tập nữ mở bán vào 15:00 ngày 18/06/2022',
    approvedSubTitle2: 'Điều kiện mua',
    approvedLine3:
        'Đợt 3: 70 NFT Áo tập nam và 30 NFT Áo tập nữ mở bán vào 15:00 ngày 21/06/2022',
    approvedLine4: 'Tổng NFT Áo nam là 100 và áo nữ là 100',
    approvedLine5: 'Mỗi tài khoản mua tối đa 1 áo nam và 1 áo nữ',
    approvedLine6: 'Đã đăng ký tài khoản và xác thực danh tính',
    approvedButton: 'Ok',

    connectPayButton: 'Kết nối ví',
    pedding: 'Đợi xác thực',
    peddingTitle: 'Tài khoản của bạn đang đợi \n xác thực',
    successVerifyTitle: 'Tài khoản của bạn đã được\n xác thực',
    successVerifyButton: 'Ok',
    message: {
        titleConnectWallet: 'Kết nối ví.',
        deviceNotSupport: 'Thiết bị không hỗ trợ.',
        connectFail: 'Kết nối thất bại.',
        opened: 'Vui lòng mở cửa số metamask để xác nhận đăng nhập.',
    },
    buttonRegister: 'Đăng ký ngay',
    buttonTextVerify: 'Xác thực ngay',
    newItemTitle: 'Tin mới nhất',
    walletTitle: 'Ví',
    walletBalance: 'Số dư',
    loadWallet: 'Nạp',
    loadWalletTitle: 'Nạp',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: 'Gửi AIS, SB, BNB, USDT vào đúng địa chỉ ví này.',
    walletAddress: 'Địa chỉ ví',
    scanAddress: 'Quét địa chỉ để nhận thanh toán',
    withdrawWallet: 'Rút',
    withdrawWalletTitle: 'Rút STE',
    commonSoon: 'Sắp ra mắt',
    okie: 'Ok',
    copyAddress: 'Sao chép địa chỉ ví thành công',
    productTitle: 'Bộ sưu tập NFT của AIS',
    remainTimeBuy: 'Thời gian bán còn lại: ',
    bannerTitle: 'Khám phá các Bộ sưu tập NFT Cao cấp, Độc đáo và Độc quyền nhất',
    line1: 'Ngày 21/06/2022 08:00 UTC',

    line2: ' Đợt 2: 70 NFT Áo tập nữ mở bán vào 15:00 ngày 18/06/2022',
    bannerSubTitle: 'Điều kiện mua',
    line3: 'Đợt 3: 70 NFT Áo tập nam và 30 NFT Áo tập nữ mở bán vào 15:00 ngày 21/06/2022',
    line4: 'Tổng NFT Áo nam là 100 và áo nữ là 100',
    line5: 'Mỗi tài khoản mua tối đa 1 áo nam và 1 áo nữ',
    line6: 'Đã đăng ký tài khoản và xác thực danh tính',
    haveOwned: 'Đã sở hữu',
    modalFire: {
        title: 'Xin chúc mừng!',
        subTitle: 'INO STE Giai đoạn <span>{count}</span> đã kết thúc',
        content1: 'Chúc mừng các thành viên đã thành công\n sở hữu NFT STE',
        content2:
            ' Nếu bạn chưa có được may mắn lần này, hãy tham gia giai đoạn <span>{count}</span> vào lúc 15:00 (VN)',
        stage1: ' ngày 18 tháng 6 tới nhé',
        stage2: ' ngày 21 tháng 6 tới nhé',
    },
    coming_soon: 'COMING SOON',
    download: 'TẢI XUỐNG',


    filter_order: 'Sắp xếp',
    filter_nft: 'Lọc theo loại NFT',
    filter_mint: 'Lọc theo số lần mint',
    filter_token: 'Lọc loại token',
    newest: 'Mới nhất',
    price_asc: 'Giá: Thấp đến Cao ↑',
    price_desc: 'Giá: Cao đến Thấp ↓',
    all: 'Tất cả',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: 'Cặp Mint',
    last1: 'Còn 1 lần',
    last2: 'Còn 2 lần',
    last3: 'Còn 3 lần',
    last4: 'Còn 4 lần',
    last5: 'Còn 5 lần',
    last6: 'Còn 6 lần',
    last7: 'Còn 7 lần',
    new: 'Mới',
    expire: 'Hết hạn tập',
    cancel_sell: 'HỦY BÁN',
    confirm_cancel: 'Hủy Bán NFT',
    price_sell: 'Giá bán:',
    fee: 'Phí bán 5%:',
    ste_receive: 'Số {0} sẽ nhận:',
    couple_des: 'Các NFT đã Mint với nhau thì phải mua bán theo cặp (NFT M và NFT W).',
    invite: 'Giới thiệu bạn bè',
    invite_title: 'Mời bạn bè',
    rule: 'Quy định',
    rule1: 'Chia sẻ ID giới thiệu / liên kết của bạn với một người bạn không có tài khoản',
    rule2: 'Người được giới thiệu phải xác thực danh tính thành công và tham gia tập luyện',
    rule3: 'Với mỗi lượt giới thiệu thành công bạn sẽ được thêm 4 ngày chơi miễn phí',
    id_invite: 'ID giới thiệu của bạn',
    linkref: 'Link invite',
    ref_code: 'Mã giới thiệu',
    copy_success: 'Sao chép thành công!',
    condition_sell: 'Điều kiện bán NFT',
    condition_sell1: '1. NFT là NEW (Chưa sử dụng).',
    condition_sell2: '2. NFT đã sử dụng thì cần nhận thưởng từ 7 lần trở lên (NFT nhận thưởng dưới 7 lần thì chưa thể bán)',
    condition_sell3: '3. Các NFT đã Mint với nhau thì phải mua bán theo cặp (NFT M và NFT W).',
    condition_sell4: '4. NFT đã sử dụng thì và nhận thưởng từ 7 lần trở lên khi đăng bán sẽ vẫn tiếp tục tính ngày đến khi hết hạn sử dụng, khi có người mua thì hạn sử dụng sẽ tự động trở thành HẾT HẠN, nếu người bán hủy bán thì hạn sử dụng sẽ bằng số ngày đang được tính.\n',
    condition_sell5: '5. NFT đang đăng bán thì không được phép sử dụng để tập.\n',
    condition_sell6: '6. NFT đã sử dụng thì phải còn lượt Mint.',
    nft_not_mint: 'Các NFT chưa Mint',
    sell: 'Bán',
    confirm_sell: 'Xác nhận Bán NFT',
    transfer_confirm: 'Xác nhận chuyển NFT',
    fee_transfer: 'Phí chuyển:',
    sell_placeholder: 'Nhập giá bán',
    valid_price: 'Vui lòng nhập giá bán',
    priceSellRequired: 'Vui lòng nhập giá bán',
    confirm_text: 'Xác nhận',
    change_price: 'Sửa giá',
    change_price_title: 'sửa giá Bán NFT',
    sell_success: 'Đăng bán nft thành công!',
    nft_minted: 'Các NFT đã Mint',
    history_title: 'Lịch sử',
    history_text: 'lịch sử giao dịch',
    nft_transaction: 'Giao dịch NFT',
    ste_transaction: 'Giao dịch STE',
    stt: 'STT',
    time: 'Thời gian',
    type_transaction: 'Loại giao dịch',
    type_nft: 'Loại NFT',
    id_nft: 'ID NFT',
    price_nft: 'Giá',
    transfer_nft: 'Người gửi / nhận',
    fee_nft: 'Phí',
    type_wallet: 'Loại Ví',
    total: 'Số Tiền',
    hash: 'Hash',
    wallet_to: 'Địa chỉ ví nhận',
    status: 'Trạng thái',
    copySuccess: 'Sao chép thành công',
    copyFail: 'Sao chép thất bại',
    not_available: 'NFT đã được bán hoặc không có sẵn!',
    transfer: "Chuyển",
    collaborators_title: "Cộng tác viên"
};
